import React, { useContext } from 'react'
import About from '../componentes/About.jsx';
import Call from '../componentes/Call.jsx';
import Callgaleria from '../componentes/Callgaleria.jsx';
import Carrusel from '../componentes/Carrusel.jsx';
import Resumen from '../componentes/Resumen.jsx';
import Valores from '../componentes/Valores.jsx';
import Donaciones from '../componentes/Donaciones.jsx';
import { ContextoDonacion } from '../contextos/Donacion.js';
import Video from '../componentes/Video.jsx';


const Home = () => {
    const { donacion, cambiar } = useContext(ContextoDonacion)
    return (
        <>
            {donacion && <Donaciones cambiar={cambiar} />}
            <Carrusel />
            <Call />
            <Video />
            <Resumen />
            <About />
            <Valores />
            <Callgaleria />
        </>
    )
}

export default Home